
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-medical-doctors",
      function () {
        return require("private-next-pages/for-medical-doctors/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-medical-doctors"])
      });
    }
  